import { getQueryStringParameter } from './utils/getQueryStringParameter';
import { useGetCanonicalPath } from './useGetCanonicalPath';

import { isUrlOnAllowlist } from './isUrlOnAllowlist';

type ReturnUser = () => {
    redirectUser: () => void;
    returnUserLinkUrl: string;
};

export const useReturnUserAfterAuth: ReturnUser = () => {
    const canonicalPath = useGetCanonicalPath();
    const returnUrl = getQueryStringParameter({
        path: canonicalPath,
        queryStringParameter: 'return_url'
    });

    const redirectUser = () => {
        if (isUrlOnAllowlist(returnUrl)) {
            window.location.assign(returnUrl);
        } else {
            window.location.assign('/my-zoopla/');
        }
    };

    const returnUserLinkUrl = isUrlOnAllowlist(returnUrl)
        ? returnUrl
        : '/my-zoopla/';

    return {
        redirectUser,
        returnUserLinkUrl
    };
};
